import React from "react";

const TableCell = ({
  value,
  center = false,
  highlight = false,
  tooltipContent = null,
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [tooltipX, setTooltipX] = React.useState(0);
  const [tooltipY, setTooltipY] = React.useState(0);

  const handleMouseEnter = (e) => {
    if (!tooltipContent) return;

    const cursorX = e.target.offsetLeft + e.target.offsetWidth / 2;
    const cursorY = e.target.offsetTop + e.target.offsetHeight / 2;
    setTooltipX(cursorX);
    setTooltipY(cursorY);
    setShowTooltip(true);
  };

  return (
    <td
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => tooltipContent && setShowTooltip(false)}
    >
      {value}
      {showTooltip && tooltipContent && (
        <div
          style={{
            position: "absolute",
            top: tooltipY,
            left: tooltipX,
            transform: "translate(-150%, -50%)",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "5px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: 2,
          }}
        >
          {tooltipContent}
        </div>
      )}
    </td>
  );
};

export default TableCell;
